<template>
  <div class="k-working-hours">
    <div v-for="(item, index) in state.days" :key="index" class="flex column row-sm no-wrap no-wrap-sm q-px-sm gap-sm gap-12 q-mb-12">
      <div class="k-working-hours__checkbox col-grow flex items-center">
        <k-checkbox v-model="item.active" class="fs-15px" :label="item.day" />
      </div>
      <div class="flex row no-wrap q-px-sm gap-sm gap-12">
        <div class="flex no-wrap items-center" :class="{'flex-1': $q.screen.lt.sm}">
          <span class="text-cool-gray-70 fs-13px q-mr-12 k-working-hours__label"> From </span>
          <div class="k-working-hours__input" :class="{'flex-1': $q.screen.lt.sm}">
            <k-input
              v-model="item.from"
              class="fs-15px"
              input-class="text-center"
              :has-clear-icon="false"
              placeholder="00:00"
              small
              mask="time"
              :error="item.invalid"
              @change="hook.handleValidateTime(item, index)"
            />
          </div>
        </div>
        <div class="flex no-wrap items-center" :class="{'flex-1': $q.screen.lt.sm}">
          <span class="text-cool-gray-70 fs-13px q-mr-12 k-working-hours__label"> To </span>
          <div class="k-working-hours__input" :class="{'flex-1': $q.screen.lt.sm}">
            <k-input
              v-model="item.to"
              class="fs-15"
              input-class="text-center"
              :has-clear-icon="false"
              placeholder="00:00"
              small
              mask="time"
              :error="item.invalid"
              @change="hook.handleValidateTime(item, index)"
            />
          </div>
        </div>
      </div>
    </div>
    <k-alert v-if="state.error.length" model="error" title="Error" icon="remove-solid" :description="state.error" />
  </div>
</template>

<script setup>
import { reactive, toRef } from 'vue'
import useWorkingHoursHook from './KWorkingHoursHook'

defineOptions({ name: 'KWorkingHours' })

const props = defineProps({
  modelValue: { type: Object, required: true },
})

const emit = defineEmits(['update:modelValue'])

const state = reactive({
  days: [
    { day: 'Monday', active: false, from: '', to: '', invalid: false },
    { day: 'Tuesday', active: false, from: '', to: '', invalid: false },
    { day: 'Wednesday', active: false, from: '', to: '', invalid: false },
    { day: 'Thursday', active: false, from: '', to: '', invalid: false },
    { day: 'Friday', active: false, from: '', to: '', invalid: false },
    { day: 'Saturday', active: false, from: '', to: '', invalid: false },
    { day: 'Sunday', active: false, from: '', to: '', invalid: false },
  ],
  error: '',
  inputValueChanged: false,
  modelValue: [],
})
state.modelValue = toRef(props, 'modelValue')

const hook = useWorkingHoursHook(state, emit)
</script>

<style lang="sass" scoped>
@import "../styles/variables.sass"
@import "../styles/mixins.sass"

.k-working-hours
  @include element('label')
    min-width: 30px
    max-width: 30px
    text-align: end
    @include at-gt-md
      min-width: 35px
      max-width: 35px
  @include element('input')
    min-width: 80px
    @include at-gt-sm
      max-width: 80px
    @include at-gt-lg
      max-width: 146px
      min-width: 146px
</style>
